import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest, apiFormRequest } from "../../services/api";
import toast from "react-hot-toast";

export const useTestimonials = () => {
  const {
    data: testimonials,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["testimonials"],
    queryFn: async () => {
      const data = await apiRequest("/testimonials/admin"); // Use admin endpoint to see all
      return data.data;
    },
  });

  return { testimonials, isLoading, error };
};

export const useCreateTestimonial = () => {
  const queryClient = useQueryClient();

  const { mutate: createTestimonial, isLoading: isCreating } = useMutation({
    mutationFn: (formData) => apiFormRequest("/testimonials", formData), // Default is POST
    onSuccess: () => {
      toast.success("Testimonial created successfully");
      queryClient.invalidateQueries(["testimonials"]);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  return { createTestimonial, isCreating };
};

export const useUpdateTestimonial = () => {
  const queryClient = useQueryClient();

  const { mutate: updateTestimonial, isLoading: isUpdating } = useMutation({
    mutationFn: ({ id, formData }) => apiFormRequest(`/testimonials/${id}`, formData, { method: "PUT" }),
    onSuccess: () => {
      toast.success("Testimonial updated successfully");
      queryClient.invalidateQueries(["testimonials"]);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  return { updateTestimonial, isUpdating };
};

export const useDeleteTestimonial = () => {
  const queryClient = useQueryClient();

  const { mutate: deleteTestimonial, isLoading: isDeleting } = useMutation({
    mutationFn: (id) => apiRequest(`/testimonials/${id}`, { method: "DELETE" }),
    onSuccess: () => {
      toast.success("Testimonial deleted successfully");
      queryClient.invalidateQueries(["testimonials"]);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  return { deleteTestimonial, isDeleting };
};

export const useDuplicateTestimonial = () => {
  const queryClient = useQueryClient();

  const { mutate: duplicateTestimonial, isLoading: isDuplicating } = useMutation({
    mutationFn: (id) => apiRequest(`/testimonials/${id}/duplicate`, { method: "POST" }),
    onSuccess: () => {
      toast.success("Testimonial duplicated successfully");
      queryClient.invalidateQueries(["testimonials"]);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  return { duplicateTestimonial, isDuplicating };
};
